import { useQuery } from '@tanstack/react-query'
import { getUserWorkExperience } from 'api/user'
import { userWorkExperience } from './keys'
import { User } from 'api/typings'

type UserWorkExperience = Awaited<ReturnType<typeof getUserWorkExperience>>

export function useUserWorkExperience({
  id,
  enabled,
}: {
  id: User['id']
} & Pick<
  Parameters<
    typeof useQuery<UserWorkExperience, Error, UserWorkExperience, string[]>
  >[0],
  'enabled'
>) {
  return useQuery({
    enabled,
    placeholderData: { workExperience: [] },
    queryKey: userWorkExperience(id),
    queryFn: async () => getUserWorkExperience(id),
    select: (result) => result.workExperience,
  })
}
